import { Validator } from '@vista-digital/validator';
import { filmWatchlistButtonEventsValidator } from '../../watchlist-button/types/events';
import { defaultFilmSummaryCdnOptions, filmSummaryCdnOptionsValidator } from './cdn-options';
import { defaultFilmSummaryConfig, filmSummaryConfigValidator } from './config';
import { defaultFilmSummaryDisplayText, filmSummaryDisplayTextValidator } from './display-text';
export const filmSummaryPropsValidator = Validator.object({
    displayText: filmSummaryDisplayTextValidator,
    config: filmSummaryConfigValidator,
    events: filmWatchlistButtonEventsValidator,
    cdnOptions: filmSummaryCdnOptionsValidator
});
export const defaultFilmSummaryProps = {
    displayText: defaultFilmSummaryDisplayText,
    config: defaultFilmSummaryConfig,
    events: {},
    cdnOptions: defaultFilmSummaryCdnOptions
};
